import { isNull, objectHasKeys } from '@/utils/comparators'

/**
* Returns true when a welcome offer product exists for current user.
* Access the welcome offer object through vuex mapState.
* @param {object} state
*/
const welcomeOfferIsAvailable = (state) => {
  return !isNull(state.welcomeOffer) && state.welcomeOffer !== false
}

/**
* Array with world credit products.
*/
const getWorldCredits = (state) => {
  let products = objectHasKeys(state.worldCredits)
    ? Object.values(state.worldCredits)
    : []
  return products
}

/**
* Array with all purchasable world credit products for current user.
*/
const getPurchasableWorldCredits = (state) => {
  let products = objectHasKeys(state.worldCredits)
    ? Object.values(state.worldCredits)
    : []
  let filtered = products.filter((b) => b.purchasable)
  return filtered
}

/**
 * Boolean result that indicates if there is any disabled world credit product
 * @param {object} state
 */
const hasDisabledWorldCreditsProduct = (state) => {
  let products = objectHasKeys(state.worldCredits)
    ? Object.values(state.worldCredits)
    : []
  let filtered = products.filter((b) => b.purchasable)
  return products.length !== filtered.length
}

/**
* Gets a world credit product by it´s id without considering if it´s purchasable or not.
* @param {integer} id
*/
const getWorldCreditById = (state) => (id) => {
  let result = objectHasKeys(state.worldCredits)
    ? state.worldCredits
    : {}
  var found = result && id in result ? result[id] : false
  return found
}

const getProducts = (state) => {
  let products = objectHasKeys(state.subscriptions)
    ? Object.values(state.subscriptions).sort((a, b) => { return a.name > b.name ? 1 : -1 })
    : []
  return products
}

const getProductById = (state) => (id) => {
  let products = objectHasKeys(state.subscriptions)
    ? state.subscriptions
    : {}

  var found = products[id] || {}
  return found
}

const getDealById = (state) => (id) => {
  return state.deals[id] || {}
}

const hasDisabledSubscriptionProduct = (state) => {
  let products = objectHasKeys(state.subscriptions)
    ? Object.values(state.subscriptions)
    : []
  let filtered = products.filter((b) => b.purchasable)
  return products.length !== filtered.length
}

export default {
  welcomeOfferIsAvailable,
  getWorldCredits,
  getPurchasableWorldCredits,
  hasDisabledWorldCreditsProduct,
  getWorldCreditById,
  getProducts,
  getProductById,
  getDealById,
  hasDisabledSubscriptionProduct
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/products/getters.js